const notUndefined = (value) => typeof value !== 'undefined';
export default notUndefined;
